import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';

import { alterarDataTabela } from '~/Services/Service';

const ModalAlterarData = ({ show, onHide, tabela, onSalvar }) => {
  const [data, setData] = useState('');
  const [saving, setSaving] = useState(false);

  React.useEffect(() => {
    if (show && tabela && tabela.data) {
      setData(moment(tabela.data).format('YYYY-MM-DD'));
    } else {
      setData('');
    }
  }, [show, tabela]);

  const handleSalvar = async () => {
    if (!data) {
      toast.error('Informe a data');
      return;
    }
    setSaving(true);
    try {
      await alterarDataTabela(tabela.codigo_tabela, { data });
      toast.success('Data alterada com sucesso');
      onSalvar();
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.message) ||
        (err.response && err.response.data) ||
        'Erro ao alterar data';
      toast.error(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Alterar Data da Tabela</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label className="small mb-1">Nova Data</Form.Label>
          <Form.Control
            type="date"
            value={data}
            onChange={(e) => setData(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSalvar} disabled={saving}>
          {saving ? 'Salvando...' : 'Salvar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAlterarData;
